import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { Autocomplete, Checkbox, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, TextField } from "@mui/material";
import { IDataPesquisarCores } from "../../types/api/cafe/pesquisar-cores-cafe";
import { onChangeMultipleValue } from "./helpers";

export default function SelectCorCafe({
    value,
    onChange,
    type = "single"
}: SelectSimpleApiQueryProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-cores-cafe"],
        queryFn: () => axiosClient.get("pesquisar-cores-cafe", {
            params: {
                limit: 50
            }
        })
    });
    const listData: IDataPesquisarCores[] = data?.data.data || []
    //

    if (type === "single") return (
        <Autocomplete
            disablePortal
            disabled={isLoading}
            id="combo-box-demo"
            value={value as SingleValue}
            options={listData.map((i) => ({ label: i.cor_nome, id: i.cor_id }))}
            onChange={(_: any, newValue: TObjValue | null) => {
                onChange(newValue);
            }}
            renderInput={(params) => <TextField {...params} label={isLoading ? "Carregando" : "Cor"} fullWidth />}
        />
    )

    //type == multiple
    const valorFormatado = (value as TObjValue[]).map((item) => `${item.id},${item.label}`)

    const handleChangeMultipleValue = (event: SelectChangeEvent<string[]>) => {
        const valorFinal = onChangeMultipleValue(event.target.value as string[])
        onChange(valorFinal as MultipleValue)
    }
    //

    return (
        <FormControl fullWidth>
            <InputLabel id="cor-cafe">{isLoading ? "Carregando" : "Cor"}</InputLabel>
            <Select
                labelId="cor-cafe"
                id="demo-multiple-name"
                multiple
                disabled={isLoading}
                value={valorFormatado}
                onChange={handleChangeMultipleValue}
                input={<OutlinedInput label="Cor" />}
                renderValue={(selected) => selected.map(e => e.split(",")[1]).join(', ')}
            >
                <MenuItem value="NaN,Todos(as)">
                    <Checkbox checked={valorFormatado.indexOf("NaN,Todos(as)") > -1} />
                    Todos(as)
                </MenuItem>

                {[...listData].map((item) => {
                    const valorOption = `${item.cor_id},${item.cor_nome}`
                    return (
                        <MenuItem
                            key={item.cor_id}
                            value={valorOption}
                        >
                            <Checkbox checked={valorFormatado.indexOf(valorOption) > -1} />
                            {item.cor_nome}
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}

interface SelectSimpleApiQueryProps {
    type?: 'single' | 'multiple';
    value: SelectValue;
    onChange: (arg: SelectValue) => void;
}

type SelectValue = SingleValue | MultipleValue;

type SingleValue = TObjValue | null;
type MultipleValue = TObjValue[];

type TObjValue = { label: string, id: number }